export const APP_ROUTES = {
  LOGIN: '/auth/login',
  NEW_PASSWORD: '/auth/new-password',
  NEW_PHONE: '/auth/new-phone',
  RESET_PASSWORD: '/auth/reset-password',
  CONFIRM_SMS: '/auth/confirm-sms',
  DASHBOARD: '/dashboard',
};
